import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import Dropdown from './Dropdown';
import { Component } from 'react';
import TabRegion from '../models/components/TabRegion';
import { AccessibilityStore, DataStore } from '../stores';
import { Theme } from '../models/Theme';

const moduleDropdownDefault = {
    marginX: '24px',
};

interface ModuleDropdownProps {
    theme?: Theme;
    dataStore?: DataStore;
    accessibilityStore?: AccessibilityStore;
}

@inject('dataStore', 'accessibilityStore')
@observer
class ModuleDropdown extends Component<ModuleDropdownProps, any> {
    render() {
        const { theme, dataStore, accessibilityStore } = this.props;

        const selectItemFn = item => {
            dataStore.logDataLayer('tab_navigation', {
                tabRegion: TabRegion.Module,
                tabLabel: item.label,
            });
            this.props.dataStore.config.setModule(item);
        };
        return (
            <Dropdown
                items={this.props.dataStore.config.modules}
                selectItemFn={selectItemFn}
                selectedItem={this.props.dataStore.config.selectedModule}
                placeHolder={'Modules'}
                chevronIcon={'ModuleDropdownChevronIcon.svg'}
                chevronIconExpanded={'ModuleDropdownChevronIconExpanded.svg'}
                {...moduleDropdownDefault}
                {...theme.ModuleDropdown}
                role="navigation"
                aria-label={accessibilityStore.modulesLandmark}
            />
        );
    }
}

export default withTheme(ModuleDropdown);



// WEBPACK FOOTER //
// ./src/Components/ModuleDropdown.tsx